import { useMemo } from 'react';

import { useFeatureControlContext } from '@shared-web/contexts/FeatureControlContext';

export function useFeatureControl() {
  const { features, loading, refetch } = useFeatureControlContext();
  const userState = useMemo(() => {
    return features?.userState;
  }, [features]);
  const accessExtend = useMemo(() => {
    return features?.accessExtend;
  }, [features]);

  return { features, userState, accessExtend, loading, refetch };
}
